import { type IPageByPinSchema } from '@/repositories/generated/shared/search-offers/entities/listing_analytics/PageByPinSchema';
import { type IPageSchema } from '@/repositories/generated/shared/search-offers/entities/listing_analytics/PageSchema';

import { listingType } from './getListingType';

type Page = IPageSchema | IPageByPinSchema;

type GetAnalyticsPageParams = {
  isNarrowListingLayout: boolean;
  page: Page;
  isPin: boolean;
  isCurrentArea: boolean;
};

export type AnalyticsPage = Page & {
  listingType: 'map' | 'list' | 'map_area';
  pageType: 'ListingHybrid' | 'Listing';
  siteType: 'desktop';
};

export function getAnalyticsPage(params: GetAnalyticsPageParams): AnalyticsPage {
  const { page, isNarrowListingLayout, isPin, isCurrentArea } = params;

  /**
   * @todo Удалить поле аналитики
   * @description Данный функционал появился в задаче CD-180587, будет удалён в задаче CD-180588
   */
  Object.assign(page.extra, { 'search-frontend': true });

  return {
    ...page,
    listingType: listingType(isPin, isCurrentArea),
    pageType: isNarrowListingLayout ? 'ListingHybrid' : 'Listing',
    siteType: 'desktop',
  };
}
